import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { templatesService } from '@/api/services/templates.service'
import {
  normalizeCustomerTemplate,
  normalizeLibraryTemplate,
} from '@/lib/templates/normalize-template'
import type { TemplateCategorySelection } from '@/lib/templates/template-category-selection'

/**
 * Routes to the right endpoint for the selected category source (see `templates.service.ts`) and
 * normalizes the result — `getCustomerTemplates`/`getAllTemplates`/`getTemplatesByCategory` each
 * return a different item shape, and the panel shouldn't have to know which.
 */
export function useTemplateListQuery(selection: TemplateCategorySelection) {
  return useQuery({
    queryKey: queryKeys.templates.list(selection),
    queryFn: async () => {
      if (selection.type === 'category') {
        const templates = await templatesService.getTemplatesByCategory(selection.categoryId)

        return templates.map(normalizeLibraryTemplate)
      }

      if (selection.key === 'custom') {
        const templates = await templatesService.getCustomerTemplates()

        return templates.map(normalizeCustomerTemplate)
      }

      const templates = await templatesService.getAllTemplates()

      return templates.map(normalizeLibraryTemplate)
    },
    staleTime: 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
